import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { SessionContext } from '../models/session-context';

@Injectable({ providedIn: 'root' })
export class LoginService {
	constructor(
		private readonly httpClient: HttpClient
	) {}

	createUrl(
		url: string,
		state?: string,
		responseType?: string,
		redirectUri?: string,
		clientId?: string,
		codeChallenge?: string,
		codeChallengeMethod?: string
	) {
		const formUrl = new URL(url, location.origin);
		const params = formUrl.searchParams;
		if (state) {
			params.set('state', state);
		}
		if (responseType) {
			params.set('response_type', responseType);
		}
		if (redirectUri) {
			params.set('redirect_uri', redirectUri);
		}
		if (clientId) {
			params.set('client_id', clientId);
		}
		if (codeChallenge) {
			params.set('code_challenge', codeChallenge);
		}
		if (codeChallengeMethod) {
			params.set('code_challenge_method', codeChallengeMethod);
		}
		return formUrl;
	}

	async challengeUser(
		username: string,
		password: string,
		rememberMe: string,
		state?: string,
		responseType?: string,
		redirectUri?: string,
		clientId?: string
	) {
		const body = new URLSearchParams();
		body.set('username', username);
		body.set('password', password);
		body.set('remember_me', rememberMe);
		await firstValueFrom(this.httpClient.post(
			this.createUrl('/rest/auth/challenge', state, responseType, redirectUri, clientId).toString(),
			body.toString(),
			{
				headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
			}
		));
	}

	async linkUser(
		username: string,
		password: string,
		state?: string,
		responseType?: string,
		redirectUri?: string,
		clientId?: string
	) {
		const body = new URLSearchParams();
		body.set('username', username);
		body.set('password', password);
		await firstValueFrom(this.httpClient.post(
			this.createUrl('/rest/auth/link', state, responseType, redirectUri, clientId).toString(),
			body.toString(),
			{
				headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
			}
		));
	}

	getSessionContext(clientId: string, redirectUri: string | undefined) {
		const url = new URL('/rest/auth/sessionContext', location.origin);
		const params = url.searchParams;
		params.set('clientId', clientId);
		if (redirectUri) {
			params.set('redirectUri', redirectUri);
		}
		return this.httpClient.get<SessionContext>(url.toString());
	}
}
